import React from 'react'
import Modal from '../../../util/modal/Modal'
import NotificationItem from './notificationItem/NotificationItem'

const NotificationModal = () => {
    return (
        <Modal>
            <NotificationItem />
        </Modal>
    )
}

export default NotificationModal
